import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { MarkingSettings } from 'src/app/models/integrations/marking/marking-settings.model';
import { ApiMarkingSettingsService, NotificationService, ValidatorsService } from 'src/app/services';
import { MarkingSettingsValidator } from '../marking-settings.validator';

@Component({
  selector: 'app-marking-settings',
  templateUrl: './marking-settings.component.html',
  styleUrls: ['./marking-settings.component.css']
})
export class MarkingSettingsComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  errorMessages: any;
  settings: MarkingSettings;
  loading: boolean;

  form: UntypedFormGroup = this.fb.group({
    id:         [null],
    apikey:     [null, this.validator.apikey],
  });


  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    private apiMarkingService: ApiMarkingSettingsService,
    private notification: NotificationService,
    private validator: MarkingSettingsValidator,
    private validatorService: ValidatorsService,
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.errorMessages = this.validator.errorMessages;
    
    this.onEdit();
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }


  /**
   * 
   */
  initForm(): void {

    if(this.settings != null){

      this.form.setValue({
        id:         this.settings.id,
        apikey:     this.settings.apikey
      });
    }
  }


  /**
   * 
   */
  onEdit(): void {

    this.progressRef.start();
    
    this.subscriptions.add(
      this.apiMarkingService.uploadInfo().subscribe((response: any) => { console.log('[RESPONSE] getCredentialData: ', response);

        if(response != null){

          this.settings = response.result;

          this.initForm();
        }

        this.progressRef.complete();
      },
      error => { 
        this.progressRef.complete(); 
      })
    );
  }


  /**
   * 
   */
  onSave(): void {

    this.progressRef.start();
    this.loading = true;

    this.subscriptions.add(
      this.apiMarkingService.uploadSave(this.form.value).subscribe((response: any) => { console.log('[RESPONSE] saveCredentialData: ', response);

        if(response != null){

          this.onEdit();
          this.notification.show('success', 'Данные успешно сохранены!');
        }

        this.progressRef.complete();
        this.loading = false;
      },
      error => { 
        this.progressRef.complete(); 
        this.loading = false;
      })
    );
  }


  /**
   * 
   * @param field 
   * @param type 
   */
  validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.form.get(field), type);
  }


  /**
   * 
   * @param field 
   */
  checkingFieldStatus(field: string): string {

    return this.validatorService.checkingFieldStatus(this.form.get(field));
  }


}
